import { render } from "./AdminCommercants.vue?vue&type=template&id=5fe45f74&scoped=true"
import script from "./AdminCommercants.vue?vue&type=script&lang=js"
export * from "./AdminCommercants.vue?vue&type=script&lang=js"

import "./AdminCommercants.vue?vue&type=style&index=0&id=5fe45f74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fe45f74"]])

export default __exports__